export var GET_HOTSHOP_LISTS = 'GET_HOTSHOP_LISTS';
export var SET_HOTSHOP_LIST = 'SET_HOTSHOP_LIST';
export var SET_HOTSHOP_PAGING = 'SET_HOTSHOP_PAGING';
export var SET_HOTSHOP_STATUS = 'SET_HOTSHOP_STATUS';